module.exports = __webpack_public_path__ + "img/l-hd.6be188d6.jpg";